import { useState } from 'react';
import styled from '@emotion/styled/macro';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import _ from 'underscore';
import DraggableRow from './DraggableRow';

const DroppableWrapper = styled('div')``;

const Container = ({ children, hideDeleteIcon, canBeEmpty, onDragEnd, onDelete }) => {
  const [droppableId] = useState(_.uniqueId('droppable-'));

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId}>
        {(provided) => (
          <DroppableWrapper ref={provided.innerRef} {...provided.droppableProps}>
            {children.map((child, index) => (
              <DraggableRow
                key={index.toString()}
                index={index}
                child={child}
                hideDeleteIcon={hideDeleteIcon}
                onDelete={onDelete}
                canBeEmpty={canBeEmpty}
              />
            ))}
            {provided.placeholder}
          </DroppableWrapper>
        )}
      </Droppable>
    </DragDropContext>
  );
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  hideDeleteIcon: PropTypes.bool,
  canBeEmpty: PropTypes.bool,
  onDragEnd: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
};

Container.defaultProps = {
  hideDeleteIcon: false,
  canBeEmpty: true,
  onDelete: () => {},
};

export default Container;
